import './select-verification-level.modal.scss';

export default function SelectVerificationLevelModal($scope, $t, close, verification, $alert) {
  'ngInject';

  $scope.verification = verification;

  $scope.close = () => {
    close();
  };

  $scope.ok = () => {
    if (!$scope.verification.level || $scope.verification.level === 'NONE') {
      $alert.error($t('shared.modals.select_verification_level.verification_level_required_error_message'));
      return;
    }

    close($scope.verification.level);
  };

}